import { Outlet, useLocation } from "react-router-dom";

export const ProfessionalEngagement = () => {
	const location = useLocation();
	const isRootPublicEngagement = location.pathname === "/publicEngagement";
	return (
		<section>
			{isRootPublicEngagement && (
				<div className="publicEngagement-submenu"></div>
			)}
			<Outlet />
		</section>
	);
};
